import axios from '../../plugins/axios';

const state = {
  user: JSON.parse(localStorage.getItem('user')),
};

const mutations = {
  setUser(currentState, user) {
    currentState.user = user;
    localStorage.setItem('user', JSON.stringify(user));
  },
};

const actions = ({
  logout({ commit, state: currentState }) {
    axios.post('auth/logout').then(() => {
      if (currentState.user?.id) {
        commit('setUser');
        localStorage.removeItem('user');
        location.reload(true);
      }
    });
  },
});

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
